module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/map_arrow-03e246fcddb161c2a4d99592bca1c81b.svg&quot;;"